import useSWR from "swr";
import {
  User,
  UserBilling,
  UserProducts,
  UserSubscription,
} from "@prisma/client";
import { parse } from "cookie";
import { useCallback } from "react";

const fetcher = async (url: string) => {
  const isLoggedOut = getLoggedOutCookie(document.cookie);
  if (isLoggedOut === 1) {
    return { user: null };
  } else {
    return fetch(url, {
      mode: "cors",
      credentials: "include",
    }).then(async (res) => {
      if (res.status === 403) {
        const error = new Error("Not authorized!");
        // @ts-ignore
        error.status = 403;
        throw error;
      } else {
        const user = await res.json();
        return { user: user ?? null };
      }
    });
  }
};

const mutateUserFetcher = async (userData: any) => {
  return fetch("/api/v0/profile/set", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(userData),
  }).then(async (res) => {
    if (res.status === 403) {
      const jsonError = await res.json();
      const error = new Error(jsonError.message ?? "Keine Berechtigung");
      // @ts-ignore
      error.status = 403;
      throw error;
    } else if (res.status >= 400) {
      const jsonError = await res.json();
      const error = new Error(
        jsonError.message ?? "Ein Fehler ist aufgetreten"
      );
      // @ts-ignore
      error.status = res.status;
      throw error;
    } else {
      const user = await res.json();
      return { user: user ?? null };
    }
  });
};
const getLoggedOutCookie = (cookies: string) => {
  const cookie = parse(cookies || "");
  if (cookie["loggedOut"]) {
    return parseInt(cookie["loggedOut"]);
  }
  return 1;
};

export interface UserData extends User {
  billing: UserBilling | null;
  products: (UserProducts & { subscriptions: UserSubscription[] }) | null;
}

export const useUser = () => {
  const {
    data,
    mutate,
    error,
    isValidating,
    revalidate,
  } = useSWR("/api/v0/user", fetcher, { shouldRetryOnError: false });
  const mutateUserData = useCallback(async ({ userData }: any) => {
    const returnedUser = await mutateUserFetcher(userData);
    mutate(returnedUser, false);
  }, []);
  const loading = !data && !error;
  const loggedOut =
    (!!error && error.status === 403) || (data && data.user === null);
  const user: UserData | null = error ? null : data ? data.user : null;
  return {
    loading,
    loggedOut,
    error,
    user,
    mutate,
    revalidate,
    mutateUserData,
  };
};
